import React, { Component, Fragment } from "react";
import { getAllowedSwitches } from "../../../../AssetTypeConfig/Reports/SwitchinspectionReport";
import { ReportGeneratorUtils } from "../../utils/reportGeneratorUtils";
import { switchReportStyle } from "../../Timps/Switch/style/index";
import { themeService } from "../../../../theme/service/activeTheme.service";
import _ from "lodash";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import ReportInfoSection from "../../../../libraries/ReportGenerator/ReportInfoSection";
import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";
import { dataFormatters } from "../../../../utils/dataFormatters";
import { ONR_CwrMaintenanceRecordFormSectionsSchema } from "./ONR_CwrMaintenanceRecordFormSchema";
import { SignatureImageImproved } from "../../utils/SignatureImage";
import ONR_CwrMaintenanceRecordFormInstructions from "./instructions";

const { generalInfo, nonConformance, repairOfCwrDefects } = ONR_CwrMaintenanceRecordFormSectionsSchema;

const ReportView = (props) => {
  let reportData = props.reportData ? props.reportData : {};
  let { location, user, date, formSummary, isMaintenance } = reportData;
  let { signatureImage } = props;
  if (!formSummary) formSummary = {};

  let data = {
    location: location,
    user: user ? user.name : "",
    reportDate: dataFormatters.dateFormatter(date),
    ...formSummary,
  };

  let reportTitle=reportData.isMaintenance ? "MR Number" : "Title"
  let formValue=reportData.isMaintenance ?  reportData.formSummary && reportData.formSummary.formId ? reportData.formSummary.formId : null : "N/A"

  return (
    <Fragment>
      <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
        <ReportTitleSection
          title="CWR Maintenance Record Form"
          {...props}
          centerTitle={true}
          fontSizeOverride="24px"
          isMaintenance={isMaintenance}
        />
        <ReportInfoSection
          centered={true}
          titleWidthOverride={{
            col1: "120px",
            col2: "120px",
          }}
          fontSizeOverride="20px"
          rows={[
            {
              col1: {
                title: reportTitle,
                value: reportData.title,
              },
              col2: {
                title: "Form ID",
                value: formValue,
              },
            },

            {
              col1: {
                title: "Location",
                value: data.location,
              },
              col2: {
                title: "Date",
                value: data.reportDate,
              },
            },
            {
              col1: {
                title: "Inspector",
                value: data.user,
              },
              col2: {
                title: "Signature",
                value: <SignatureImageImproved signatureImage={signatureImage} />,
              },
            },
          ]}
        />
        <span className="spacer"></span>
        <table className="table-bordered" style={{ width: "100%" }}>
          <ReportTableSectionRenderer section={generalInfo} rowsData={data.cmrf} />
        </table>
        <table className="table-bordered" style={{ width: "100%" }}>
          <tbody>
            <tr className="grey-background">
              <td colSpan={2} rowSpan={2}>
                <b>Defect Type:</b>
              </td>
              <td colSpan={3} rowSpan={1}>
                TB - Track Buckle
              </td>
              <td colSpan={3} rowSpan={1}>
                PA - Pull Apart
              </td>
              <td colSpan={3} rowSpan={1}>
                TR - Tight Rail
              </td>
              <td colSpan={9} rowSpan={1}>
                RR - Rail Replaced during ordinary maintenance (e.g., new rail in crossing)
              </td>
            </tr>
            <tr className="grey-background">
              <td colSpan={3} rowSpan={1}>
                BJ - Broken Joint Bar(s)
              </td>
              <td colSpan={3} rowSpan={1}>
                PI - Panel Installation
              </td>
              <td colSpan={3} rowSpan={1}>
                TW - Thermite Welding
              </td>
              <td colSpan={9} rowSpan={1}>
                BR - Broken Rail
              </td>
            </tr>
          </tbody>
        </table>
        <table className="table-bordered" style={{ width: "100%" }}>
          <ReportTableSectionRenderer section={nonConformance} rowsData={data.cmrf} />
        </table>
        <table className="table-bordered" style={{ width: "100%" }}>
          <ReportTableSectionRenderer section={repairOfCwrDefects} rowsData={data.cmrf} />
        </table>
      </div>
      <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
        <ONR_CwrMaintenanceRecordFormInstructions />
      </div>
    </Fragment>
  );
};

const ONR_CwrMaintenanceRecordForm = (props) => {
  const { inspec } = props;
  const isMaintenance = props.isMaintenance ? props.isMaintenance : ReportGeneratorUtils.checkIfMaintenance(inspec);
  const title = inspec.title ? inspec.title : null;
  let formSummaries = isMaintenance
    ? ReportGeneratorUtils.getMaintenanceAppForms(inspec, ["onr_m_cwrMaintenanceRecordForm"])
    : ReportGeneratorUtils.getInspectionAppForms(inspec, ["onr_i_cwrMaintenanceRecordForm"]);

  const additionalReportParams = {
    location: isMaintenance ? ReportGeneratorUtils.getMaintenanceLocation(inspec) : ReportGeneratorUtils.getInspectionLocation(inspec),
    date: ReportGeneratorUtils.getInspectionDate(inspec),
    user: ReportGeneratorUtils.getInspectionUser(inspec),
    isMaintenance: isMaintenance,
  };

  return formSummaries.map((summary, _i) => (
    <ReportView
      {...props}
      reportData={{
        title: title,
        formSummary: summary,
        ...additionalReportParams,
      }}
    />
  ));
};

export default ONR_CwrMaintenanceRecordForm;



// WEBPACK FOOTER //
// ./src/components/Reports/ONR/CwrMaintenanceRecordForm/index.jsx